
<!-- <app-go-to-project></app-go-to-project> -->
<div class="floor-number" *ngIf="!unika">{{ 'FLOOR' | translate }} {{ this.floorNumber }}</div>
<div class="floor-number title-holder" *ngIf="unika">
    <div class="title"> {{ 'VIEW FROM FLOOR' | translate }} </div>
    <div class="text">{{ this.floorNumber }}</div>
</div>
<div *ngIf="showIframe" @anim class="view-from-floor-panorama-holder" [innerHtml]="'<iframe src=' + this.mainSpiricalSrc + '?s=' + this.curFloorPanorama + '></iframe>' | safe: 'html'"></div>